module.exports = __webpack_public_path__ + "resources/img/img_dataflow_m_en.e00996476216ae890ce88eba9ddbdaf2.png";